const updateUsersErrors = (state, { payload: { errors } }) => {
	state.errors = errors;
};

export default updateUsersErrors;
